module.exports = __webpack_public_path__ + "static/media/Logout.bde8bda6.svg";